import * as build from '../build.json';

export const environment = {
  production: true,
  build: build['default'],
  apiUrl: 'https://api.dataflash.news/api',
  filesUrl: "https://api.dataflash.news/public",
}
